import axios from 'axios';
import handler from './handler';
import qs from 'qs';

const baseDomain = '';
const baseURL = `${baseDomain}/api`;

let token = document.head.querySelector('meta[name="csrf-token"]');
let bearer = document.head.querySelector('meta[name="api-token"]');

const axiosInstance = axios.create({
  baseURL,
  headers: {
    'X-CSRF-TOKEN': token.content,
    'Authorization': `Bearer ${bearer.content}`,
  },
  paramsSerializer: (p) => {
    return qs.stringify(p, {arrayFormat: 'brackets'});
  }
});

axiosInstance.interceptors.response.use(
  response => response,
  error => handler(error)
);

export const ErrorlessRepository = axios.create({
  baseURL,
  headers: {
    'X-CSRF-TOKEN': token.content,
    'Authorization': `Bearer ${bearer.content}`,
  },
});

export default axiosInstance;
